import { useState } from "react";
import { useNavigate } from "react-router-dom";

function AddToCartPopup({ productDetails, openAddCartPopupfunction, addToCartsize, setaddToBagButtonDisplayStatusfunction,addToCartSpecialPrice}) {
  console.log(productDetails);
  const navigate = useNavigate();  
  const [showAddToCartPopup, setshowAddToCartPopup] = useState(true)

  const onCheckoutClick = () => {    
    // setIsModalOpen(false);
    setshowAddToCartPopup(false);
    setaddToBagButtonDisplayStatusfunction("block");
    return navigate("/checkout");
  };

  const closeAddToCartPopup = () =>{
    setaddToBagButtonDisplayStatusfunction("block");
    openAddCartPopupfunction(false);
  }

  return (
    <>
      {showAddToCartPopup && (
        <div
          className="newsletter"
          id="product-sold-ou-notify-me"
          style={{ display: "block", zIndex: "9999", padding: "0px" }}
        >
          <div className="bg"></div>
          <div className="center-box">
            <div className="newsletter-heading">
              <button
                onClick={closeAddToCartPopup}
                className="btn-blank btn-side-cart-close"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/Cross-Button.png"
                  }
                  className="close-btn-newsletter"
                  alt=""
                />
              </button>
              {/* <h3>THIS ITEM GOT SOLD OUT1</h3> */}
            </div>
            <div className="newsletter-body">
              <div className="row">
                <div className="col-md-11 mx-auto" style={{width:"45%"}}>
                  <div className="txt text-center mt-20">
                    <img src={productDetails?.images[0]?.src} alt={''} style={{height:"160px",width:"100%"}}/>
                  </div>
                </div>
                <div className="col-md-11 mx-auto" style={{width:"50%"}}>
                  <div className="txt text-center mt-20">
                    <h4 className="text-black"><b>Added to Bag</b></h4><br/>
                    <h6 className="text-black">
                      <b>
                        {productDetails?.designer_name || ""}
                      </b>  
                    </h6>
                    <p className="text-grey" style={{fontSize: "13px"}}>
                        {productDetails?.name || ""}
                    </p>
                    <br/>                    
                    <p className="text-grey">
                        Size: <b>{addToCartsize}</b>
                    </p>
                    <p className="text-grey">
                        price: <b>{addToCartSpecialPrice}</b>
                    </p>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <button
                  type="button"
                  onClick={onCheckoutClick}
                  className="btn-primary btn-fw mt-30"
                >
                  CHECKOUT
                </button>
              </div>
            </div>
          </div>
        </div>
      )}      
    </>
  );
}

export default AddToCartPopup;
